/**
 * Imports all image paths to be used in react.
 */
export const imagesContext = require.context('~/assets/images', true, /\.(png|jpg|jpeg|gif|ico|svg|webp)$/);

imagesContext.keys().forEach(imagesContext);
